const AUTH_STORAGE_KEY = 'syngenta_chat_auth';

export const authUtils = {

  saveCredentials: (credentials) => {
    try {
      const authData = {
        userId: credentials.userId,
        tenant: credentials.tenant,
        token: credentials.token,
        timestamp: Date.now()
      };
      localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
      return true;
    } catch (error) {
      console.error('Error saving credentials to localStorage:', error);
      return false;
    }
  },

  getCredentials: () => {
    try {
      const authData = localStorage.getItem(AUTH_STORAGE_KEY);
      if (!authData) return null;
      
      const parsed = JSON.parse(authData);
      return {
        userId: parsed.userId,
        tenant: parsed.tenant,
        token: parsed.token,
        timestamp: parsed.timestamp
      };
    } catch (error) {
      console.error('Error getting credentials from localStorage:', error);
      return null;
    }
  },

  clearCredentials: () => {
    try {
      localStorage.removeItem(AUTH_STORAGE_KEY);
      return true;
    } catch (error) {
      console.error('Error clearing credentials from localStorage:', error);
      return false;
    }
  },

  isAuthenticated: () => {
    const credentials = authUtils.getCredentials();
    return credentials !== null && credentials.userId && credentials.tenant && credentials.token;
  },

  getEncodedCredentials: () => {
    const credentials = authUtils.getCredentials();
    if (!credentials) return null;

    try {
      const credentialsObj = {
        user_id: parseInt(credentials.userId),
        tenant: credentials.tenant,
        token: credentials.token
      };
      return btoa(JSON.stringify(credentialsObj));
    } catch (error) {
      console.error('Error encoding credentials:', error);
      return null;
    }
  },

  getUserInfo: () => {
    const credentials = authUtils.getCredentials();
    if (!credentials) return null;

    return {
      userId: credentials.userId,
      tenant: credentials.tenant,
      token: credentials.token
    };
  }
};

export default authUtils;
